import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import { FIRST_ROW_PULSE_CARDS } from './constants';
import { Button, Modal } from '../../../ps-aspect-design';
import PulseCard from './PulseCard/PulseCard';
import './PulseLandingPage.scss';

PulseLandingPage.propTypes = {
  geoUrl: string,
  skillsUrl: string
};

function PulseLandingPage(props) {
  const { geoUrl, skillsUrl, selectedCurrencyCode } = props;
  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const isIncompatibleCurrency = selectedCurrencyCode !== 'USD' && selectedCurrencyCode !== '%';

  useEffect(() => {
    if (!history.state?.state?.fromCurrencySelect) {
      setShowCurrencyModal(isIncompatibleCurrency);
    }
  }, [selectedCurrencyCode]);

  function renderCard(card) {
    const isGeoCard = card.title.includes('Geo');
    const isSkillCard = card.title.includes('Skill');

    return (
      <PulseCard
        description={card.description}
        imagePath={card.imagePath}
        key={card.title.toLowerCase()}
        title={card.title}
        url={isGeoCard ? geoUrl : isSkillCard ? skillsUrl : card.url}
        setShowCurrencyModal={setShowCurrencyModal}
        isIncompatibleCurrency={isGeoCard && isIncompatibleCurrency}
      />
    );
  }

  function closeCurrencyModal() {
    setShowCurrencyModal(false);
  }

  function renderContent() {
    return (
      <div className="pulse-landing-page">
        <section className="pulse-header__container">
          <h1 className="pulse-header__title">Differentials Engine</h1>
          <p className="pulse-header__sub-title">
            Powered by PayScale data, this feature provides differentials by quarter and year and the ability to apply
            differentials to get a full picture of the market.
          </p>
        </section>
        <section className="pulse-content__container">
          <div className="pulse-row">{FIRST_ROW_PULSE_CARDS.map(renderCard)}</div>
        </section>
        <Modal isOpen={showCurrencyModal} onClose={closeCurrencyModal} className="pulse-currency-modal">
          <h3>Change Currency</h3>
          <div className="pulse-currency-modal__body">
            The differentials engine only provides geo and skill differentials data for the US. To view differentials
            data, please change the currency to <b>USD</b> or <b>All Currencies</b>.
          </div>
          <Button className="pulse-currency-modal__btn" variant="primary" onClick={closeCurrencyModal}>
            OK
          </Button>
        </Modal>
      </div>
    );
  }

  return renderContent();
}

export default PulseLandingPage;
